export enum EPersonType {
  Person = "person",
  Company = "company",
}

export enum EConnectionType {
  NoConnection = "no_connection",
  Accepted = "accepted",
  DuplicateWithoutConnection = "duplicate_without_connection",
}

export enum EDummyType {
  Email = "email",
  Phone = "phone",
}

export const getFilterQuery = (values: {
  queryParams: {
    query: string | undefined;
    page: number | undefined;
    personType: EPersonType | undefined;
    connectionType: EConnectionType | undefined;
    dummyTypes: EDummyType[] | undefined;
    bookkeeping: boolean | undefined;
    tagIds: string[] | undefined;
  };
  dummyEmail: string | undefined;
  dummyPhone: string | undefined;
}) => {
  const { queryParams, dummyEmail, dummyPhone } = values;
  const { query, personType, connectionType, dummyTypes, bookkeeping, tagIds } =
    queryParams;

  const newFilter: { [key: string]: any } = {
    where: {},
    order: "lastname ASC",
  };

  const and: { [key: string]: any }[] = [
    {
      or: [
        {
          type: { neq: "F" },
        },
        { type: null },
      ],
    },
  ];

  if (query) {
    newFilter.search = query;
  }

  if (personType) {
    and.push({
      isCompany: personType === EPersonType.Company,
    });
  }

  if (connectionType) {
    switch (connectionType) {
      case EConnectionType.NoConnection:
        and.push({
          inviteAcceptedAt: { eq: null },
          duplicateWithoutConnection: { eq: false },
        });
        break;

      case EConnectionType.Accepted:
        and.push({
          inviteAcceptedAt: { neq: null },
          duplicateWithoutConnection: { eq: false },
        });
        break;

      case EConnectionType.DuplicateWithoutConnection:
        and.push({
          duplicateWithoutConnection: { eq: true },
        });
        break;

      default:
        break;
    }
  }

  if (dummyTypes && dummyTypes.length > 0) {
    dummyTypes.forEach(x => {
      if (x === EDummyType.Email && dummyEmail) {
        and.push({
          email: { eq: dummyEmail },
        });
      }

      if (x === EDummyType.Phone && dummyPhone) {
        and.push({
          phone: { eq: dummyPhone },
        });
      }
    });
  }

  if (bookkeeping !== undefined) {
    and.push({
      efApiKeyForBookkeeping: bookkeeping ? { neq: null } : { eq: null },
    });
  }

  if (and.length === 1) {
    newFilter.where = and[0];
  } else if (and.length > 1) {
    newFilter.where = {
      and,
    };
  }

  if (tagIds && tagIds.length > 0) {
    newFilter.where = { ...newFilter.where, tagIds: tagIds.map(Number) };
  }

  return newFilter;
};
